<template>
    <div>
        <div v-if="!editing" :class="reactiveClass">
            <b-link title="Cliquer pour modifier" @click="edit">
                <span v-if="form.amount !== 0" class="number-font">
                    {{ Number.parseFloat(form.amount).toFixed(0) }}
                </span>
                <span v-else class="number-font">-</span>
            </b-link>
        </div>
        <div v-if="editing">
            <b-input-group>
                <b-input-group-prepend>
                    <b-button
                        title="Annuler"
                        style="height: 20px; padding: 0"
                        size="sm"
                        @click="display"
                    >
                        <i class="fas fa-fw fa-times"></i>
                    </b-button>
                </b-input-group-prepend>
                <b-input
                    v-model="form.amount"
                    size="sm"
                    class="text-right number-font"
                    @change="update"
                />
            </b-input-group>
        </div>
    </div>
</template>

<script>
import TableFormHandler from '../../../../common/mixins/TableFormHandler.vue'

export default {
    name: 'TableBudgetUpdater',

    mixins: [TableFormHandler],

    props: {
        amount: 0,
        client: null,
        month: null,
        year: null,
        budgetOption: null,
    },

    data() {
        return {
            editing: false,
            form: {},
        }
    },

    created() {
        this.align = 'right'
        this.initForm()
    },

    methods: {
        initForm() {
            this.form.amount = this.amount
            this.form.year = this.year
            this.form.month = this.month
            this.form.budget_option_id = this.budgetOption
            this.form.client = parseInt(this.client)
        },

        edit() {
            this.editing = true
        },

        display() {
            this.editing = false
        },

        async update() {
            try {
                await axios.post('/budget', this.form)
                this.handleSuccess()
                this.display()
                this.$root.$refs.clientTableBudgets.getData()
            } catch (error) {
                this.initForm()
                this.display()
                this.handleError()
                console.log(error)
            }
        },
    },
}
</script>

<style scoped>
.form-control-sm {
    height: 20px !important;
    padding-top: 0 !important;
    padding-bottom: 0 !important;
    font-size: 12px;
}
</style>
